import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-nowrap" }
const _hoisted_3 = { class: "flex-1 mr-20" }
const _hoisted_4 = {
  key: 0,
  class: "list-none -mt-10 mb-x4"
}
const _hoisted_5 = { class: "flex flex-nowrap items-start justify-start" }
const _hoisted_6 = { class: "w-25 inline-block" }
const _hoisted_7 = { class: "inline-block mr-auto" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "text-roman"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex flex-nowrap items-start justify-start" }
const _hoisted_12 = { class: "w-25 inline-block" }
const _hoisted_13 = { class: "inline-block mr-auto" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = ["onClick"]

import { Form } from 'vee-validate';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import InputText from '@/shared/form/InputText.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import ConfirmationButton from '@/shared/form/ConfirmationButton.vue';
import useBasket from '@/b2c/basket/useBasket';
import {
    AddRedeemCodeRequest,
    BasketCheckoutModelSummary,
    BasketModelSummary, GiftCardPaymentModel,
    PromoCodeModel,
} from '@/b2c/shared/api/server-apis';
import { useCheckout } from '@/b2c/checkout/useCheckout';
import { computed, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketActionAddCoupon',
  props: {
    checkoutMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { checkoutMode: boolean }



const labels = useBlockLabels();
const { addRedeemCode, removePromoCode, removeGiftCard, summary: basketSummary } = useBasket();
const { addGiftCardPayment, removeGiftCardPayment, summary: checkoutSummary } = useCheckout();

const summary = computed<BasketModelSummary | BasketCheckoutModelSummary>(() => props.checkoutMode ? checkoutSummary.value : basketSummary.value);
const appliedPromoCodes = computed<PromoCodeModel[]>(() => (summary.value as BasketModelSummary).appliedPromoCodes ?? []);
const appliedGiftCardPayments = computed<GiftCardPaymentModel[]>(() => summary.value.appliedGiftCardPayments ?? []);

const messageId = 'basketSummaryActionAddCoupon';
const formValidation = { redeemCode: 'required' };

const submit = async(request: AddRedeemCodeRequest, { resetForm }): Promise<void> => {
    if (props.checkoutMode) {
        await addGiftCardPayment(request, messageId);
    } else {
        await addRedeemCode(request, messageId);
    }
    resetForm();
};

const removeGiftCardAction = async(code: string): Promise<void> => {
    if (props.checkoutMode) {
        await removeGiftCardPayment(code, messageId);
    } else {
        await removeGiftCard(code, messageId);
    }
};


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(Form), {
      "validation-schema": formValidation,
      onSubmit: submit
    }, {
      default: _withCtx(({ isSubmitting, errors }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(InputText, {
              name: "redeemCode",
              class: "w-full",
              autocomplete: "off",
              label: _unref(labels).basketSummaryAddCouponOrGiftCard
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(ConfirmationButton, {
              class: "c-button--outline min-w-100 u-valign-inline-button",
              confirm: isSubmitting,
              text: _unref(labels).basketSummaryAddCouponCodeButton,
              "confirmation-text": _unref(labels).basketSummaryAddCouponCodeButtonPending
            }, null, 8, ["confirm", "text", "confirmation-text"])
          ])
        ]),
        (!errors.redeemCode)
          ? (_openBlock(), _createBlock(WebApiMessage, {
              key: 0,
              id: messageId,
              "clear-timing": 5000,
              class: "absolute -mt-39"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(appliedPromoCodes).length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          _createVNode(_TransitionGroup, { name: "o-anim-fade-300" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appliedPromoCodes), (promo) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: promo.redeemCode,
                  class: "mt-5"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (promo.isActive)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_6, [
                            _createVNode(_component_c_icon, {
                              name: "icon-checkmark-medium",
                              class: "h-12 -mt-3"
                            })
                          ]),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$dictionary.format(_unref(labels).basketSummaryAppliedCouponText, [promo.redeemCode.toString()])), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ml-10 text-dusty-grey c-magic-line c-magic-line--underline",
                            onClick: ($event: any) => (_unref(removePromoCode)(promo.redeemCode))
                          }, _toDisplayString(_unref(labels).basketSummaryRemoveAppliedCouponButton), 9, _hoisted_8)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$dictionary.format(_unref(labels).basketSummaryInvalidCouponText, [promo.redeemCode])), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ml-10",
                            onClick: ($event: any) => (_unref(removePromoCode)(promo.redeemCode))
                          }, [
                            _createVNode(_component_c_icon, {
                              name: "icon-plus",
                              class: "-mt-3 h-18 rotate-45"
                            })
                          ], 8, _hoisted_10)
                        ]))
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(appliedGiftCardPayments).length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 1,
          class: _normalizeClass(["list-none -mt-10 mb-x4", { 'mb-x6': __props.checkoutMode }])
        }, [
          _createVNode(_TransitionGroup, { name: "o-anim-fade-300" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summary).appliedGiftCardPayments, (appliedGiftcard) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: appliedGiftcard.giftCardNumber,
                  class: "mt-5"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_c_icon, {
                        name: "icon-checkmark-medium",
                        class: "h-12 -mt-3"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).basketSummaryAddGiftCardApplied, { giftcardnumber: appliedGiftcard.giftCardNumber })), 1),
                      _hoisted_14,
                      _createElementVNode("small", null, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).basketSummaryAddGiftCardRemaining, { amount: appliedGiftcard.remainingAmount.amount })), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ml-10 text-dusty-grey c-magic-line c-magic-line--underline",
                      onClick: ($event: any) => (removeGiftCardAction(appliedGiftcard.giftCardNumber))
                    }, _toDisplayString(_unref(labels).basketSummaryRemoveAppliedCouponButton), 9, _hoisted_15)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})